import { clearAllFiltersFromSession } from "@utils/SessionStorage";

class SessionManager {
  constructor() {
    this.setAnonymous();
    this.setUserConfirmed(false);
    this.inactivityTimeout = null;
    this.inactivityDuration = 15 * 60 * 1000;
    this.setupInactivityDetection();
  }

  isAnonymous() {
    return this.user === null;
  }

  isAuthenticated() {
    return !this.isAnonymous();
  }

  setAnonymous() {
    this.user = null;
  }

  setUserConfirmed(confirmed) {
    this.userConfirmed = confirmed;
  }

  setUser(user) {
    this.user = {
      id: user["id"],
      roles: user["roles"] || [],
      username: user["username"],
      fullName: user["full_name"],
      locationPid: user["location_pid"],
      userType: user["user_types"],
      contactNumber: user["contact_number"],
      department: user["department"],
      program: user["program"],
      year: user["year"],
      semester: user["semester"],
      library_id: user["library_id"],
    };
    // Start inactivity timer when user is set
    this.resetInactivityTimer();
  }

  setupInactivityDetection() {
    // Events that indicate user activity
    const activityEvents = [
      "mousedown",
      "mousemove",
      "keypress",
      "scroll",
      "touchstart",
      "click",
    ];

    // Reset timer on any activity
    activityEvents.forEach((event) => {
      document.addEventListener(
        event,
        () => {
          if (this.isAuthenticated()) {
            this.resetInactivityTimer();
          }
        },
        true
      );
    });
  }

  resetInactivityTimer() {
    // Clear existing timeout
    if (this.inactivityTimeout) {
      clearTimeout(this.inactivityTimeout);
    }

    // Set new timeout
    this.inactivityTimeout = setTimeout(() => {
      this.handleInactivityTimeout();
    }, this.inactivityDuration);
  }

  handleInactivityTimeout() {
    if (this.isAuthenticated()) {
      this.resetSession();
      window.dispatchEvent(new CustomEvent("sessionTimeout"));
    }
  }

  resetSession() {
    // Clear user data
    this.setAnonymous();
    this.setUserConfirmed(false);

    // Clear all filters from session storage
    clearAllFiltersFromSession();

    // Clear the inactivity timeout
    if (this.inactivityTimeout) {
      clearTimeout(this.inactivityTimeout);
      this.inactivityTimeout = null;
    }
  }

  // Method to update inactivity duration
  setInactivityDuration(minutes) {
    this.inactivityDuration = minutes * 60 * 1000;
    if (this.isAuthenticated()) {
      this.resetInactivityTimer();
    }
  }

  // Manual logout
  logout() {
    this.resetSession();
  }
}

export const sessionManager = new SessionManager();
